import axios from "axios";
import { configUrl } from "config";

const createPayment = async (payload) => {
    try {
        const response = await axios.post(
            `${configUrl.AssessmentServer}/api/ProviderPayment`,
            payload
        );

        return response?.data;
    } catch (error) {
        console.error("Create Payment Error:", error?.response || error);
        return null;
    }
};

export default createPayment;
